// extracted by mini-css-extract-plugin
module.exports = {"normal":"balance_normal__10t1-","center":"balance_center__OVY54"};